import { CheckBox } from 'Components/CheckBox';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isWebView } from 'Utilities/webview';
import { Drawer } from 'vaul';
import './styles.scss';

interface PropsModel {
	checked: boolean;
	href?: string;
	className?: string;
	toggleTermAndCondition: (checked: boolean) => void;
}

const TermAndConditionAgreed = (props: PropsModel) => {
	const { t } = useTranslation();
	const { checked, href, toggleTermAndCondition, className } = props;
	const webView = isWebView();
	const [open, setOpen] = useState(false);

	// Inside the partner webview, target="_blank" is not reliable across hosts
	// (Vikki, ...) since it depends on how the host webview chooses to handle
	// new-tab navigation. Instead of relying on the host, show the terms inline
	// via an iframe in a bottom-sheet drawer — same pattern the s247 mobile app
	// uses for its StaticPage terms modal — so no host-side implementation is needed.
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		if (!webView || !href) return;
		e.preventDefault();
		setOpen(true);
	};

	// Mirrors the s247 mobile app's StaticPage convention (`?mobileapp=true`) so the
	// embedded page knows to hide its own header/nav when rendered inside our iframe.
	const getIframeSrc = () => {
		if (!href) return href;
		const url = new URL(href, window.location.origin);
		url.searchParams.set('mobileapp', 'true');
		return url.toString();
	};

	return (
		<div className={`d-flex ${className}`}>
			<CheckBox
				className={'mr-3'}
				checked={checked}
				onChange={(e) => toggleTermAndCondition(e.target.checked)}
			/>
			<span className={'fs-p-md-2 lh-p-md-2 text-secondary'}>
				{t('order_bill_term_and_service_1')}{' '}
				<a
					target={webView ? undefined : '_blank'}
					href={href}
					className={'text-primary'}
					onClick={handleClick}
				>
					{t('order_bill_term_and_service_2')}
				</a>{' '}
				{t('order_bill_term_and_service_3')}
			</span>
			{webView && href && (
				<Drawer.Root open={open} onOpenChange={setOpen} snapPoints={[0.5, 1]}>
					<Drawer.Portal>
						<Drawer.Overlay className="term-and-condition-agreed-drawer-overlay" />
						<Drawer.Content className="term-and-condition-agreed-drawer-content">
							<Drawer.Handle className="term-and-condition-agreed-drawer-handle" />
							<Drawer.Title className="term-and-condition-agreed-drawer-title">
								{t('order_bill_term_and_service_2')}
								<Drawer.Close
									className="term-and-condition-agreed-drawer-close"
									aria-label="close"
								>
									×
								</Drawer.Close>
							</Drawer.Title>
							<iframe
								src={getIframeSrc()}
								title={t('order_bill_term_and_service_2')}
								className="term-and-condition-agreed-iframe"
							/>
						</Drawer.Content>
					</Drawer.Portal>
				</Drawer.Root>
			)}
		</div>
	);
};

export default TermAndConditionAgreed;
